module.exports = __webpack_public_path__ + "static/fonts/DMSans-Bold.07185303.ttf";